import { Center, Text3D, useGLTF } from "@react-three/drei";
import { animated } from "@react-spring/three";
import OutToken from "../moveTokens/OutToken";
import { useAtom } from 'jotai';
import { languageAtom } from '../GlobalState';
import translations from '../dictionaries/translations';

export default function OutAlert({ position, rotation, scale }) {
  const [language] = useAtom(languageAtom);
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json";

  return (
    <animated.group position={position} rotation={rotation} scale={scale}>
      <mesh
        castShadow
        receiveShadow
        scale={[3.3 , 0.055, 1]}
      >
        <cylinderGeometry args={[1, 1, 1, 64]}/>
        <meshStandardMaterial color='black' opacity={0.9} transparent/>
      </mesh>
      <Center position={[-0.6, 0.3, 0.1]} key={Math.random()}>
        <Text3D
          font={fontUrl}
          rotation={[Math.PI/2, Math.PI, Math.PI]}
          size={0.4}
          height={0.01}
          lineHeight={0.8}
        >
          {translations.alerts.lostInSpace[language]}
          <meshStandardMaterial color="grey"/>
        </Text3D>
      </Center>
      <OutToken rotation={[0, Math.PI/2, 0]} position={[2, 0, 0]} scale={0.9}/>
    </animated.group>
  )
}